module.exports = __webpack_public_path__ + "img/header-engagementRingsFancy.d71b2ef.webp";